import { CSSProperties, FC, ReactElement } from 'react';

import { MarketingAction } from '../../entities/MarketingAction/MarketingAction';

import './MarketingActionLabel.scss';

interface MarketingActionLabel {
    marketingAction: MarketingAction;
    className?: string;
}

export const MarketingActionLabel: FC<MarketingActionLabel> = ({
    marketingAction,
    className = '',
}): ReactElement => {
    const cssVariables = {
        '--c-marketing-action-text': marketingAction.colorText,
        '--c-marketing-action-label': marketingAction.colorLabel,
    } as CSSProperties;

    return (
        <div style={cssVariables} className={`marketing-action-label ${className}`}>
            <p className="marketing-action-label__text">
                {marketingAction.label}
            </p>
        </div>
    );
};
